<template>
    <div class="machine">
        <div class="machine__image"
             :style="{backgroundImage: `url(${machine.images[0].href}?width=350)`}"></div>
        <div class="machine__text">
            <h3 class="machine__title">{{ `${machine.manufacturer.value} ${machine.model}` }}</h3>
            <div class="machine__price">
                <span>{{ machine.price.value | price }}</span>
                <div v-if="nettoPrice" class="machine__price--netto">
                    <span>{{ nettoPrice  | price }}</span> inkl. {{ machine.vat.value }}% MwSt.
                </div>
            </div>
            <div class="spacer"></div>
            <div class="machine__footer">
                <router-link
                  class="readmore"
                  :to="{
                    name: routename,
                    params:{
                      id: machine.id
                    }
                  }">Mehr Erfahren</router-link>
            </div>
        </div>
    </div>
</template>

<script type="text/babel">
module.exports = {
  name: 'Machine',
  props: {
    machine: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {};
  },
  computed: {
    nettoPrice() {
      if (this.machine.vat.value === 0) return null;
      return this.machine.price.value * (1 + (this.machine.vat.value / 100));
    },
    routename() {
      return `${this.$route.name}.details`;
    },
  },
  filters: {
    price(value) {
      if (value === 0) return 'Preis auf Anfrage';
      return value.toLocaleString('de-DE', {
        maximumSignificantDigits: 3,
        style: 'currency',
        currency: 'EUR',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
    .machine {
        border-radius: 4px;
        overflow: hidden;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.22);
        display: flex;
        flex-direction: column;
        .readmore {
            /*border: solid 2px;*/
            border-radius: 12px 0 0;
            text-decoration: none;
            padding: .75em;
            display: table;
            /*margin: auto;*/
            font-weight: 500;
            text-align: center;
            background: linear-gradient(to right, var(--gradient-color-1), var(--gradient-color-2));
            color: #fff;
        }
        &__text {
            background: #fff;
            padding: .5em;
            border-radius: 4px;
            margin-top: -4px;
            flex-grow: 1;
            display: flex;
            flex-direction: column;
        }
        &__title {
            // height: 2em;
            font-size: 1.5em;
            background: #fff;
            margin: 0 0 1em;
            font-weight: 300;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            // clip-path: polygon(0% 0%, 95% 0%, 100% 1em, 100% 100%, 0 100%)
        }
        &__price {
            font-size: 2em;
            background: linear-gradient(to right, var(--gradient-color-1), var(--gradient-color-2));
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            font-weight: 800;
            text-align: center;
            margin: 1em 0;
            &--netto {
                font-size: .5em;
            }
        }
        &__image {
            width: 100%;
            background: none center/cover;
            &:after {
                content: '';
                display: block;
                padding-top: #{100% / 4 * 3};
            }
        }
        &__footer {
            display: flex;
            justify-content: flex-end;
            margin: 0 -.5em -.5em;
        }
    }
</style>
